var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDuplicateInput(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 20,
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4396_28266",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 2,
    width: 15.1533,
    height: 15.1533,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4396_28266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.68286 13.3639C6.3356 13.3639 6.03832 13.2403 5.79103 12.993C5.54373 12.7457 5.42008 12.4484 5.42008 12.1012V4.5245C5.42008 4.17723 5.54373 3.87995 5.79103 3.63266C6.03832 3.38537 6.3356 3.26172 6.68286 3.26172H12.3654C12.7126 3.26172 13.0099 3.38537 13.2572 3.63266C13.5045 3.87995 13.6281 4.17723 13.6281 4.5245V12.1012C13.6281 12.4484 13.5045 12.7457 13.2572 12.993C13.0099 13.2403 12.7126 13.3639 12.3654 13.3639H6.68286ZM4.15731 15.8895C3.81004 15.8895 3.51277 15.7658 3.26547 15.5185C3.01818 15.2713 2.89453 14.974 2.89453 14.6267V5.78727H4.15731V14.6267H11.1026V15.8895H4.15731Z",
    fill: "#EEEEEE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateInput);
export default __webpack_public_path__ + "static/media/duplicate-input.fc4dbe74916401bb0d21e89338a4e91e.svg";
export { ForwardRef as ReactComponent };